import { ComponentType } from 'react';
import { getPlatformComponent } from '@direct-frontend/platform-code';

import { PageHeadProps } from './types';

export const PageHead = getPlatformComponent<ComponentType<PageHeadProps>>({
    desktop: import('./PageHead@desktop'),
    mobile: import('./PageHead@mobile'),
});
